import { render, staticRenderFns } from "./DetailsCreate.vue?vue&type=template&id=7d3e9eba"
import script from "./DetailsCreate.vue?vue&type=script&lang=js"
export * from "./DetailsCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports